module.exports = __webpack_public_path__ + "static/media/masao.5ec2c2fc.png";